import { createSelector } from 'reselect'

import featureStateSelector from './featureStateSelector'

export const sitesManagementListSelector = createSelector(featureStateSelector, (state) => {
  const { pages, currentPage } = state.pagination
  return (pages[currentPage] || []).map((id) => state.sitesManagementDashboard[id])
})
